import React, {useMemo} from "react";
import {Card, CardActions, CardContent, Divider, Typography} from "@mui/material";
import {CardData, UserAvatar} from "@atttomyx/react-components";
import {datetime, formatters, objects, strings, time} from "@atttomyx/shared-utils";
import {signatureUtils} from "../../utils";
import {formatPhone} from "../../utils/nodes";
import {misc, times} from "@atttomyx/shared-constants";
import {RANK_GOLD, TYPE_INVENTOR} from "../../constants";
import "./userCard.css";

const getCount = (idsByUserId, userId) => {
    const ids = objects.defaultIfNullOrUndefined(idsByUserId[userId], []);

    return ids.length;
};

const getLastLogin = (timestamp) => {
    const millisecondsSince = Date.now() - timestamp;
    const formatted = time.formatRemainingHuge(millisecondsSince);
    const clazz = millisecondsSince > times.month
        ? "inactive"
        : millisecondsSince < times.week
            ? "active"
            : undefined;

    return <span className={clazz}>{formatted}</span>;
}

const getRank = (rank) => {
    const lower = strings.sanitizeStr(rank).toLowerCase();
    const clazz = lower === "gold" ? "gold"
        : lower === "silver" ? "silver"
        : "bronze";
    const alias = rank === RANK_GOLD ? "Supreme" : rank;

    return <span className={clazz}>{alias}</span>;
}

const UserCard = (props) => {
    const { user, me, documentIdsByUserId, submission, counts, filters, children } = props;
    let n = 0;

    const keyToMetadata = useMemo(() => {
        const ret = {
            email: {
                title: "Email",
            },
            phone: {
                title: "Phone",
                formatter: formatPhone,
            },
            login: {
                title: "Login",
                formatter: (data) => data ? getLastLogin(data) : "-",
            },
        };

        if (user.settings.type === TYPE_INVENTOR) {
            ret.music = {
                title: "Listened",
                getter: (data) => counts ? counts.music : false,
                formatter: formatters.booleanToString,
            };

            ret.numVideos = {
                title: "Watched",
                getter: (data) => counts ? counts.videos : 0,
            };

            ret.numDocuments = {
                title: "Downloaded",
                getter: (data) => counts ? counts.documents : 0,
            };

            ret.numFiles = {
                title: "Uploaded",
                getter: (data) => getCount(documentIdsByUserId, data.id),
            };

            ret.rank = {
                title: "Rank",
                getter: (data) => user.settings.rank,
                formatter: (data) => getRank(user.settings.rank),
            };
        }

        ret.created = {
            title: "Created",
                formatter: datetime.getFullDateAndTime,
        };

        ret.updated = {
            title: "Updated",
                formatter: datetime.getFullDateAndTime,
        };

        return ret;
    }, [user]);

    return <Card className="user-card" raised={true}>
        <CardContent>
            <UserAvatar user={user} mode="right"/>
            {me.roles.admin ?
                <>
                    <Typography variant="caption" component="div" className="role">
                        ({(user.settings.type ? user.settings.type : misc.UNKNOWN).toLowerCase()})
                    </Typography>
                    <CardData
                        filters={filters}
                        data={user}
                        keyToMetadata={keyToMetadata}
                    />
                </> : null}
            {submission ?
                <>
                    <Divider/>
                    <div className="questionnaire">
                        {submission.questions.map(question => <div key={"question" + n++}>
                            <Typography variant="caption" component="div" className="ask">
                                {question.ask}
                            </Typography>
                            {signatureUtils.isImage(question.reply) ?
                                <img src={question.reply} alt="signature" className="signature"/> :
                                <Typography variant="caption" component="div" className="reply">
                                    {question.reply ? question.reply : "-"}
                                </Typography>}
                        </div>)}
                    </div>
                </> : null}
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default UserCard;
